import { cloneDeep } from "lodash-es";

export default class Utility
{
    static Transfrom_Folder(_items, folderId)
    {

        const pathItems: any = cloneDeep(_items);
        const path = [];

        let currentFolder = null;

        if (folderId)
        {
            currentFolder = pathItems.find(item => item.id.toString() === folderId);
            console.log(currentFolder, 'currentFolder');
            path.push(currentFolder);
        }
        console.log(path, 'path');


        while (currentFolder?.folderId)
        {
            currentFolder = pathItems.find(item => item.id === currentFolder.folderId);
            if (currentFolder)
            {
                path.unshift(currentFolder);
            }
        }
        return path;

    }

    static TransformFolder_Data(data)
    {
        let object = data.map((element: any) =>
        {
            let obj: any = {};

            obj.Id = element.Id || element.id;
            obj.ParentId = element.ParentId != null ? element.ParentId : element.parentId;
            obj.Name = element.Name || element.name || element.AlbumName || element.albumName;
            obj.BanglaName = element.BanglaName || element.banglaName;
            obj.ThumbnailPath = element.ThumbnailPath || element.thumbnailPath;
            obj.ThumbnailLink = element.ThumbnailLink || element.thumbnailLink;
            obj.AlbumType = element.AlbumType != null ? element.AlbumType : element.albumType;
            obj.AlbumOrder = element.AlbumOrder != null ? element.AlbumOrder : element.albumOrder;
            obj.TotalHitCount = element.TotalHitCount != null ? element.TotalHitCount : element.totalHitCount;
            obj.IsActive = element.IsActive != null ? element.IsActive : element.isActive;
            obj.TotalSubFolder = element.TotalSubFolder != null ? element.TotalSubFolder : element.totalSubFolder;
            obj.TotalImage = element.TotalImage != null ? element.TotalImage : element.totalImage;
            obj.LastUpdated = element.LastUpdated || element.lastUpdated;

            obj.AlbumId = element.AlbumId || element.albumId;

            obj.ImageOrder = element.ImageOrder != null ? element.ImageOrder : element.imageOrder;
            obj.ImagePath = element.ImagePath || element.imagePath;
            obj.ImageLink = element.ImageLink || element.imageLink;
            obj.IsAlbumFolder = element.IsAlbumFolder != null ? element.IsAlbumFolder : (element.isAlbumFolder != null ? element.isAlbumFolder : true);

            return obj;
        });

        return object;
    }

    static GBEnum()
    {
        let gbs = [
            { id: 1, Name: "Chief Patron" },
            { id: 2, Name: "Commander" },
            { id: 3, Name: "Chief Patron" },
            { id: 4, Name: "Chairmen" },
            { id: 5, Name: "Vice-Chairmen" },
            { id: 6, Name: "Principal" },
            { id: 7, Name: "Principal (School)" },
            { id: 8, Name: "Principal (College)" },
            { id: 9, Name: "Shift In-charge" },
            { id: 10, Name: "Shift In-charge (BV)" },
            { id: 11, Name: "Shift In-charge (EV)" },
            { id: 12, Name: "Vice-Principal" },
            { id: 13, Name: "Member" },
            { id: 14, Name: "Representative" },
            { id: 15, Name: "Managing Director" },
            { id: 16, Name: "Director" },
            { id: 17, Name: "Professor" },
            { id: 18, Name: "Assists. Professor" },
            { id: 19, Name: "First Asst Vice President" },
            { id: 20, Name: "Senior Teacher" }
        ];

        return gbs
    }
}
